import fetch from '../../fetch';
import { IHttpMethod } from '../../../ts/enums/fetch-enums';
import { ILoggedBusiness } from '../../../interfaces/i-logged-business';
import type {
  IBusinessCnae,
  IPlatformBusiness,
  IUpdatePlatformBusinessData,
} from '../platform-businesses';

const controllerName = 'business';

export interface IBusinessCnaeOption extends IBusinessCnae {
  value: string;
  label: string;
}

export async function getPublicBusinessBySlug(slug?: string) {
  const resolvedPath = slug ? `${controllerName}/${slug}` : controllerName;

  const { data } = await fetch<ILoggedBusiness>({
    method: IHttpMethod.GET,
    path: resolvedPath,
  });

  return data;
}

export async function getAuthenticatedBusiness() {
  const { data } = await fetch<IPlatformBusiness>({
    method: IHttpMethod.GET,
    path: `${controllerName}/me`,
  });

  return data;
}

export async function getBusinessCnaeOptions() {
  const { data } = await fetch<IBusinessCnaeOption[]>({
    method: IHttpMethod.GET,
    path: `${controllerName}/cnaes`,
  });

  return data;
}

export async function updateAuthenticatedBusiness(
  business: IUpdatePlatformBusinessData
) {
  const { data } = await fetch<IPlatformBusiness>({
    method: IHttpMethod.PATCH,
    path: `${controllerName}/me`,
    data: business,
  });

  return data;
}
